<template>
  <div class="form-group">
    <label>{{label}}</label>
    <input
      v-model="data"
      :type="type"
      :class="[inputClass, {'is-invalid': errors.has(name)}]"
      v-validate="rule"
      :name="name"
      :data-vv-as="label"
      :disabled="disabled"
    >
    <div v-if="errors.first(name)" class="invalid-feedback">{{ errors.first(name) }}</div>
  </div>
</template>
<script>
  import isEqual from 'lodash/isEqual'

  export default {
    inject: {
      $validator: '$validator',
    },
    props: {
      value: {},
      type: {
        type: String,
        default: 'text',
      },
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      rule: {
        default: 'required',
      },
      disabled: {
        default: false,
      },
      inputClass: {
        default: 'form-control form-control-lg',
      },
    },
    data () {
      return {
        data: this.value,
      }
    },
    watch: {
      data (value) {
        this.$emit('input', value)
      },
      value () {
        if (!isEqual(this.value, this.data)) {
          this.data = this.value
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/input-form-custom.vue